<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="listQuery.ear_code" placeholder="请输入耳标编号" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.chip_code" placeholder="请输入芯片编号" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.qr_code_address" placeholder="请输入二维码地址" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.loan_subject" placeholder="请输入贷款主体" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.loan_subject_text" placeholder="请输入贷款主体姓名" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.contact_phone" placeholder="请输入联系电话" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.supplier_name" placeholder="请输入供应商名称" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.status" placeholder="请输入状态 0:未分配 1：未激活 2：已激活 3：已注销 4：损坏/丢失" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.source" placeholder="请输入来源 0：系统生成 1：第三方" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-input v-model="listQuery.batch_number" placeholder="请输入生成批次" style="width: 300px;" clearable @change="SearchData" @keyup.enter.native="SearchData" />
      <el-date-picker v-model="listQuery.create_time" type="datetimerange" align="right" value-format="yyyy-MM-dd HH:mm:ss" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']"></el-date-picker>

      <el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button v-auth="'EarTag.create'" class="action-item" type="primary" icon="el-icon-edit" @click="HandleCreate">添加</el-button>
        <el-button v-auth="'EarTag.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>
        // 导入-待开发
        // 下载模板-待开发
        <el-button v-auth="'EarTag.export'" class="action-item" icon="el-icon-download" type="primary" @click="exportPopup = true"> 导出 </el-button>

      </el-button-group>
    </div>
    <!--表开始-->
    <el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" @sort-change="sortChange">
      <!--列开始-->
      <el-table-column type="selection"></el-table-column>
      <el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
      <el-table-column align="center" prop="ear_code" label="耳标编号 "> </el-table-column>
      <el-table-column align="center" prop="chip_code" label="芯片编号 "> </el-table-column>
      <el-table-column align="center" prop="qr_code_address" label="二维码地址 "> </el-table-column>
      <el-table-column align="center" prop="loan_subject_text" label="贷款主体姓名 "> </el-table-column>
      <el-table-column align="center" prop="contact_phone" label="联系电话 "> </el-table-column>
      <el-table-column align="center" prop="supplier_name" label="供应商名称 "> </el-table-column>
      <el-table-column align="center" prop="status" label="状态 0:未分配 1：未激活 2：已激活 3：已注销 4：损坏/丢失 "> </el-table-column>
      <el-table-column align="center" prop="source" label="来源 0：系统生成 1：第三方 "> </el-table-column>
      <el-table-column align="center" prop="batch_number" label="生成批次 "> </el-table-column>
      <el-table-column align="center" prop="create_time" label="创建时间（时间戳） "> </el-table-column>

      <el-table-column align="center" prop="" label="操作" width="200" class-name="action">
        <template slot-scope="scopes">
          <el-button v-auth="'EarTag.update'" plain icon="el-icon-edit" size="mini" @click="HandleUpdate(scopes.row)">编辑</el-button>
          <el-button v-auth="'EarTag.delete'" plain icon="el-icon-delete" size="mini" @click="RowDelete(scopes.row)">删除</el-button>

        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="loadData" />
    <!--弹窗编辑/新增窗体-->
    <el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px" style="width: 100%;">
        <el-form-item label="耳标编号" prop="ear_code">
          <el-input v-model="temp.ear_code" />
        </el-form-item>
        <el-form-item label="芯片编号" prop="chip_code">
          <el-input v-model="temp.chip_code" />
        </el-form-item>
        <el-form-item label="二维码地址" prop="qr_code_address">
          <el-input v-model="temp.qr_code_address" />
        </el-form-item>
        <el-form-item label="贷款主体" prop="loan_subject">
          <el-input v-model="temp.loan_subject" />
        </el-form-item>
        <el-form-item label="贷款主体姓名" prop="loan_subject_text">
          <el-input v-model="temp.loan_subject_text" />
        </el-form-item>
        <el-form-item label="联系电话" prop="contact_phone">
          <el-input v-model="temp.contact_phone" />
        </el-form-item>
        <el-form-item label="供应商名称" prop="supplier_name">
          <el-input v-model="temp.supplier_name" />
        </el-form-item>
        <el-form-item label="状态 0:未分配 1：未激活 2：已激活 3：已注销 4：损坏/丢失" prop="status">
          <el-input v-model="temp.status" />
        </el-form-item>
        <el-form-item label="来源 0：系统生成 1：第三方" prop="source">
          <el-input v-model="temp.source" />
        </el-form-item>
        <el-form-item label="生成批次" prop="batch_number">
          <el-input v-model="temp.batch_number" />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="ConfirmData">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/IoT_devices/ear_tag"; // 和数据交互相关写在api 方便复用
import Pagination from "@/components/Pagination"; // 分页 给予 el-pagination 的二次封装
import commonList from "@/utils/commonList";
import WangEditor from "@/components/WangEditor";
import FileList from "@/components/attachment/FileList";
import dict_data from "@/api/system/dict_data";

export default {
  name: "EarTag",
  components: { Pagination, WangEditor, FileList },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {},
      temp: {},
      listQuery: {
        page: 1,
        limit: 10, // 页大小
        order: "DESC", // 默认排序方式,
        sort: "id",
      },
      // 字典参数
      dictionary: [],
      // 字典参数
    };
  },
  created() {
    this.loadData();
    dict_data
      .Drop({ sort: "sort", order: "asc", isPaginator: false, dict_code: "" })
      .then((response) => {
        this.dictionary = response.data;
      });
  },
  methods: {
    resetTemp() {
      this.temp = {
        id: undefined,
        order_no: 99999,
        ear_code: "",
        chip_code: "",
        qr_code_address: "",
        loan_subject: "",
        loan_subject_text: "",
        contact_phone: "",
        supplier_name: "",
        status: "",
        source: "",
        batch_number: "",
      };
    },
  },
};
</script>
